import React, { useEffect, useState } from 'react';
import '../../styles/vendeurs/VendeurAccueil.css';
import { useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
import NotificationVendeur from '../../components/vendeur/NotificationVendeur';

function VendeurAccueil() {
  const [vendeur, setVendeur] = useState(null);
  const navigate = useNavigate();
  const [afficherNotifications, setAfficherNotifications] = useState(false);

  useEffect(() => {
  const data = localStorage.getItem('vendeurConnecte');
  if (data) {
    try {
      const parsed = JSON.parse(data);
      setVendeur(parsed);
      navigate('/vendeur/produits');

    } catch (err) {
      console.error("Erreur parsing localStorage vendeurConnecte :", err);
    }
  } else {
    navigate('/vendeur/login');
  }

  // ✅ Affiche les notifications seulement si demandé
  const showNotif = localStorage.getItem('voirNotifications');
  if (showNotif === 'true') {
    setAfficherNotifications(true);
    localStorage.removeItem('voirNotifications');
  }
}, [navigate]);

  return (
    <div className="vendeur-accueil-wrapper">
      <div className="vendeur-accueil-container">
        <h1>Bienvenue sur votre ndeur 🎉</h1>
        <p>Félicitations, votre compte a été validé avec succès.</p>


        {/* ✅ Notifications */}
{vendeur && afficherNotifications && (
  <div className="notifications-section">
    <h3>📩 Vos notifications</h3>
    <NotificationVendeur vendeurId={vendeur.id} />
  </div>
)}
      </div>
    </div>
  );
}

export default VendeurAccueil;
